export default __webpack_public_path__ + "static/media/80s_bg_left@3x.27a0fc64.jpg";